export default __webpack_public_path__ + "static/media/doc7.7f47b7d9.jpeg";